import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from './SafeIcon';
import { FiDollarSign, FiFilter } from 'react-icons/fi';

const BudgetFilter = () => {
  const [activeTier, setActiveTier] = useState(2);
  const tiers = [
    { level: 1, label: 'Low', icon: '$' },
    { level: 2, label: 'Med', icon: '$$' },
    { level: 3, label: 'High', icon: '$$$' },
    { level: 4, label: 'Max', icon: '$$$$' },
  ];

  return (
    <div className="bg-asphalt-800 border border-asphalt-600 rounded-lg p-3 flex items-center space-x-4">
      <div className="flex items-center text-transit-400">
        <SafeIcon icon={FiFilter} className="mr-2" />
        <span className="text-xs font-mono tracking-wider">BUDGET_SYS</span>
      </div>
      
      <div className="flex space-x-1">
        {tiers.map((tier) => (
          <button
            key={tier.level}
            onClick={() => setActiveTier(tier.level)}
            className={`relative px-3 py-1 text-xs font-mono rounded transition-colors duration-200 ${
              activeTier === tier.level 
                ? 'text-asphalt-900 bg-amber-500 font-bold' 
                : 'text-gray-400 hover:text-amber-400 hover:bg-asphalt-700'
            }`}
          >
            {tier.icon}
            {activeTier === tier.level && (
              <motion.div
                layoutId="budget-highlight"
                className="absolute inset-0 bg-amber-500 rounded -z-10"
                transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
              />
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default BudgetFilter;